import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const ToolbarGrabSplatIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M16.34 12.21C16.98 10.24 17.54 8.53 16.5 7.5C15.47 6.47 13.76 7.02 11.79 7.66C8.57002 8.7 4.92002 9.89 2.33003 6.01C2.10003 5.67 1.63003 5.57 1.29003 5.8C0.950025 6.03 0.850025 6.5 1.08003 6.84C4.30003 11.67 9.09002 10.12 12.25 9.09C13.56 8.66 15.06 8.18 15.44 8.56C15.82 8.94 15.34 10.43 14.91 11.75C13.88 14.92 12.33 19.7 17.16 22.92C17.5 23.15 17.97 23.06 18.2 22.71C18.43 22.37 18.34 21.9 17.99 21.67C14.1 19.08 15.29 15.43 16.33 12.21H16.34Z"
        fill={color}
      />
      <path
        d="M23.02 0.299988H19.24C18.88 0.299988 18.69 0.739988 18.95 0.999988L20.53 2.57999L18.26 4.84999C18.02 5.08999 18.01 5.48999 18.26 5.72999C18.5 5.96999 18.9 5.96999 19.14 5.72999L21.41 3.45999L22.99 5.03999C23.25 5.29999 23.69 5.11999 23.69 4.74999V0.979988C23.69 0.599988 23.39 0.299988 23.01 0.299988H23.02Z"
        fill={color}
      />
      <path
        d="M4.38 19H3.37C3.02758 19 2.75 19.2776 2.75 19.62V20.63C2.75 20.9724 3.02758 21.25 3.37 21.25H4.38C4.72242 21.25 5 20.9724 5 20.63V19.62C5 19.2776 4.72242 19 4.38 19Z"
        fill={color}
      />
      <path
        d="M9.63 18.75H8.62C8.27758 18.75 8 19.0276 8 19.37V20.38C8 20.7224 8.27758 21 8.62 21H9.63C9.97242 21 10.25 20.7224 10.25 20.38V19.37C10.25 19.0276 9.97242 18.75 9.63 18.75Z"
        fill={color}
      />
      <path
        d="M10.63 12.75H9.62C9.27758 12.75 9 13.0276 9 13.37V14.38C9 14.7224 9.27758 15 9.62 15H10.63C10.9724 15 11.25 14.7224 11.25 14.38V13.37C11.25 13.0276 10.9724 12.75 10.63 12.75Z"
        fill={color}
      />
      <path
        d="M4.63 13.75H3.62C3.27758 13.75 3 14.0276 3 14.37V15.38C3 15.7224 3.27758 16 3.62 16H4.63C4.97242 16 5.25 15.7224 5.25 15.38V14.37C5.25 14.0276 4.97242 13.75 4.63 13.75Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ToolbarGrabSplatIcon.displayName = 'ToolbarGrabSplatIcon';
